module.exports = __webpack_public_path__ + "img/Ford-F-150-2.ac7e7606.png";